// import React from 'react';
// import PropTypes from 'prop-types';
// import MutationManager from './Mutation';
import gql from 'graphql-tag';

const SEND_USER_PROFILES = gql`
    mutation sendUserProfiles($email: String) {
        sendUserProfiles(email: $email) {
            internalCode
        }
    }
`;

export default SEND_USER_PROFILES;
